"use client";

import React from "react";

type Props = { children: React.ReactNode; fallback?: React.ReactNode; message: string };
type State = { hasError: boolean };

export class FunnelPlannerErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("FunnelPlannerErrorBoundary caught:", error, info);
  }

  override render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="flex min-h-[60vh] items-center justify-center">
          <p className="text-sm text-muted-foreground">{this.props.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}
